import React from "react";
import Banner from "../components/comman/Banner";
import TermSection from "../components/terms/TermSection";
const Terms = () => {
    return (
        <div>
            <Banner title="Terms" />
            <TermSection />
        </div>
    );
}

export default Terms;